fbm.add("util/ui", [], function() {

	function handleClick(event) {
		if (event && event.target && event.target.tagName !== 'A') {
			event.preventDefault();
		}
		let input = document.querySelector("[contenteditable='true']");
		if (input) {
			input.focus();
		}
	}

	function registerHandlers() {
		document.getElementById('crt').addEventListener('click', handleClick);
	}

	return {
		registerHandlers,
	}
})
